const CANONICAL_VCS_ORIGIN = 'https://vcs.sixsmithgames.com';
const RETIRED_VCS_HOSTS = new Set(['virtual-combat-simulator-x1tf.vercel.app']);

/**
 * Return the canonical VCS URL when a retired deployment host is opened.
 *
 * WHY: Clerk validates the browser Origin header. The retired Vercel alias is
 * not an allowed Clerk origin, so Clerk remains unloaded and protected routes
 * appear to hang forever. Redirect before mounting Clerk to preserve the
 * requested route while using the allowed origin.
 * date_of_change: 2026-07-27
 */
export function getCanonicalHostRedirect(locationLike = typeof window !== 'undefined' ? window.location : null) {
  if (!locationLike || !RETIRED_VCS_HOSTS.has(String(locationLike.hostname || '').toLowerCase())) {
    return null;
  }

  const target = new URL(CANONICAL_VCS_ORIGIN);
  target.pathname = locationLike.pathname || '/';
  target.search = locationLike.search || '';
  target.hash = locationLike.hash || '';
  return target.toString();
}

export { CANONICAL_VCS_ORIGIN };
